<mat-tab-group color="transparent" animationDuration="0ms" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabSelection($event)">    
    <mat-tab *ngFor="let tab of eduObject" [label]="tab.title" [aria-label]="(tab.previouslySelected && !tab.isSelected) ? 'selected' : 'notselected'" class="tab-default">
      <mat-vertical-stepper #stepper (selectionChange)="onStepSelection($event)">
        <!-- <ng-template matStepLabel> </ng-template> -->
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="number">
          <mat-icon>circle</mat-icon>
        </ng-template>
        <mat-step *ngFor="let step of tab.lessons; let i = index" [label]="step.title" [expanded]="expandedStep === i" (opened)="onStepOpened(i)">
          <div [innerHtml]="step.content"></div> 
        </mat-step>
      </mat-vertical-stepper>
    </mat-tab>
</mat-tab-group>